import { memo, ReactNode, useCallback, useState } from 'react'
import { INotification } from 'components/types/Notification'
import uniqueId from 'lodash/uniqueId'

import { NotificationContext } from './NotificationContext'

interface IProps {
  children: ReactNode
}

export const NotificationProvider = memo<IProps>(function NotificationProvider({ children }) {
  const [items, setItems] = useState<INotification[]>([])

  const handleAdd = useCallback((notification: INotification) => {
    const newNotification = { ...notification, id: uniqueId('notification_') }

    setItems((state) => state.concat(newNotification))

    return newNotification
  }, [])

  const handleRemove = useCallback((notification: INotification) => {
    setItems((state) => state.filter((i) => i !== notification))
  }, [])

  return (
    <NotificationContext.Provider value={{ items, handleAdd, handleRemove }}>{children}</NotificationContext.Provider>
  )
})
